import generateRender from 'shared/utils/generateRender';
import DefaultContainer from './DefaultContainer';

const SessionExpireContainer = generateRender({
  default: DefaultContainer,
});

export default SessionExpireContainer;

